export enum AppRouteNames {
  NewUserRegistration = "new-user-registration",
  FbsHubRegistration = "fbs-hub-registration",
  GasShopRegistration = "gas-shop-registration",
  InvitedUserRegistration = "invited-user-registration",
  NotFound = "not-found",
  MobilityRegistration = "mobility-registration",
  RegistrationOverview = "registration-overview",
  VerifyEmail = "verify-email",
}
